`<template lang="pug">
  div
    table-fixed-header(
      fieldTitle="Date of Change"
      relationshipTitle="Relationship Types"
      valuesTitle="Changed Fields"
      )
      .modifications-row-wrap(v-for='data in tableData.data')
        record-modifications-row(
          v-for='item of data'
          :key='item.id + item.type'
          :item="item"
          )

    .show-more__btn(v-if="showButton")
      show-more(@show-more="showModal")

</template>

<script>
import { mapActions, mapMutations, } from 'vuex'
import { TOGGLE_MODIFICATIONS_MODAL, CHANGE_MODIFICATION_TYPE, } from '@/store/modules/record/mutations-types'

import ShowMore from '@/components/record-details/ShowMore'
import TableFixedHeader from '@/components/record-details/modifications/ModificationFixedHeader'

export default {
  name: 'RecordModificationsBlock',
  components: {
    RecordModificationsRow: () => import('@/components/record-details/modifications/RecordModificationsRow'),
    TableFixedHeader,
    ShowMore,
  },
  props: {
    tableData: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {
      currentPage: 1,
      lastPage: 1,
    }
  },
  computed: {
    modificationType () {
      return this.tableData.type
    },
    showButton () {
      return this.currentPage < this.lastPage
    },
  },
  mounted () {
    this.parsePagination(this.tableData)
  },
  methods: {
    showModal () {
      this.toggleModal({ show: true, })
      this.changeModificationType(this.modificationType)
    },
    parsePagination (data) {
      this.lastPage = data.pagination.lastPage
      this.currentPage = data.pagination.currentPage
    },

    ...mapActions('record', [ 'getRecordModifications', ]),
    ...mapMutations('record', {
      toggleModal: TOGGLE_MODIFICATIONS_MODAL,
      changeModificationType: CHANGE_MODIFICATION_TYPE,
    }),
  },
}
</script>

<style scoped lang="stylus">
  @import "../../../assets/styles/variables.styl"

  .modifications-row-wrap
    margin-bottom: 8px
    width: 100%

  .show-more__btn
    margin-top: 20px

</style>



// WEBPACK FOOTER //
// src/components/record-details/modifications/RecordModificationsBlock.vue